"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.condominiumWatcher = condominiumWatcher;
exports.editCondo = editCondo;
exports.editCondoConfiguration = editCondoConfiguration;
exports.getCondo = getCondo;
exports.removeAdminFromCondo = removeAdminFromCondo;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _variables = require("../variables");
var _variables2 = require("../../Auth/variables");
var _services = require("../../../services");
var _variables3 = require("../../Notification/variables");
var _utils = require("../../../utils");
var _helpers = require("@qwkin/helpers");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(condominiumWatcher);
function getCondo(_ref) {
  var payload = _ref.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _response$data, _response$data2, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.CondominiumService.getCondo, payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables.GET_CONDO_SUCCESS,
            payload: response
          });
        case 6:
          _context.next = 16;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 13;
          return (0, _effects.put)({
            type: _variables.GET_CONDO_FAIL,
            payload: _response
          });
        case 13:
          _context.next = 15;
          return (0, _effects.put)({
            type: _variables3.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: _response
            }
          });
        case 15:
          (0, _utils.logErr)((_response$data2 = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  })();
}
function editCondo(_ref3) {
  var payload = _ref3.payload,
    _ref3$callback = _ref3.callback,
    callback = _ref3$callback === void 0 ? _helpers.identity : _ref3$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var response, _response2$data, _response2$data2, _response2;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.CondominiumService.editCondo, payload);
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)({
            type: _variables2.EDIT_CONDO_DATA,
            payload: response
          });
        case 6:
          _context2.next = 8;
          return (0, _effects.put)({
            type: _variables.EDIT_CONDO_SUCCESS
          });
        case 8:
          _context2.next = 10;
          return (0, _effects.put)({
            type: _variables3.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Condominium edited successfully'
            }
          });
        case 10:
          callback();
          _context2.next = 21;
          break;
        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](0);
          _response2 = _context2.t0.response;
          _context2.next = 18;
          return (0, _effects.put)({
            type: _variables.EDIT_CONDO_FAIL,
            payload: _response2
          });
        case 18:
          _context2.next = 20;
          return (0, _effects.put)({
            type: _variables3.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response2$data = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data !== void 0 ? _response2$data : {}),
              data: _response2
            }
          });
        case 20:
          (0, _utils.logErr)((_response2$data2 = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data2 !== void 0 ? _response2$data2 : {});
        case 21:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 13]]);
  })();
}
function editCondoConfiguration(_ref5) {
  var payload = _ref5.payload,
    _ref5$callback = _ref5.callback,
    callback = _ref5$callback === void 0 ? _helpers.identity : _ref5$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var response, _response3$data, _response3$data2, _response3;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.CondominiumService.editCondoConfiguration, payload);
        case 3:
          response = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)({
            type: _variables2.EDIT_CONDO_CONFIGURATION_DATA,
            payload: response
          });
        case 6:
          _context3.next = 8;
          return (0, _effects.put)({
            type: _variables.EDIT_CONDO_CONFIGURATION_SUCCESS
          });
        case 8:
          _context3.next = 10;
          return (0, _effects.put)({
            type: _variables3.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Condominium edited successfully'
            }
          });
        case 10:
          callback();
          _context3.next = 21;
          break;
        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](0);
          _response3 = _context3.t0.response;
          _context3.next = 18;
          return (0, _effects.put)({
            type: _variables.EDIT_CONDO_CONFIGURATION_FAIL,
            payload: _response3
          });
        case 18:
          _context3.next = 20;
          return (0, _effects.put)({
            type: _variables3.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response3$data = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data !== void 0 ? _response3$data : {}),
              data: _response3
            }
          });
        case 20:
          (0, _utils.logErr)((_response3$data2 = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data2 !== void 0 ? _response3$data2 : {});
        case 21:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 13]]);
  })();
}
function removeAdminFromCondo(_ref7) {
  var payload = _ref7.payload,
    meta = _ref7.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response, _response4$data, _response4$data2, _response4;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.CondominiumService.removeAdminFromCondo, payload);
        case 3:
          response = _context4.sent;
          _context4.next = 6;
          return (0, _effects.put)({
            type: _variables.REMOVE_ADMIN_FROM_CONDO_SUCCESS,
            payload: response
          });
        case 6:
          _context4.next = 8;
          return (0, _effects.put)({
            type: _variables3.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Staff member successfully removed'
            }
          });
        case 8:
          meta === null || meta === void 0 || meta.callback(response === null || response === void 0 ? void 0 : response.data);
          _context4.next = 19;
          break;
        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](0);
          _response4 = _context4.t0.response;
          _context4.next = 16;
          return (0, _effects.put)({
            type: _variables.REMOVE_ADMIN_FROM_CONDO_FAIL,
            payload: _response4
          });
        case 16:
          _context4.next = 18;
          return (0, _effects.put)({
            type: _variables3.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response4$data = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data !== void 0 ? _response4$data : {}),
              data: _response4
            }
          });
        case 18:
          (0, _utils.logErr)((_response4$data2 = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data2 !== void 0 ? _response4$data2 : {});
        case 19:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 11]]);
  })();
}
function condominiumWatcher() {
  return _regenerator["default"].wrap(function condominiumWatcher$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables.EDIT_CONDO_REQUEST, editCondo), (0, _effects.takeLatest)(_variables.EDIT_CONDO_CONFIGURATION_REQUEST, editCondoConfiguration), (0, _effects.takeLatest)(_variables.GET_CONDO_REQUEST, getCondo), (0, _effects.takeLatest)(_variables.REMOVE_ADMIN_FROM_CONDO_REQUEST, removeAdminFromCondo)]);
      case 2:
      case "end":
        return _context5.stop();
    }
  }, _marked);
}